import { flagsStore, langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";

import { InpaintingPanel } from "@/modules/editor/components/common/InpaintingPanel";
import { statusStore } from "@/stores/status";
import { Actions } from "@/utils/api";
import { Editor_Words } from "@/utils/lang/editor";
import { useOwnToast } from "@/utils/misc";
import { getNodeDisplayWH } from "../../utils/misc";
import BizGenerateButton from "@/components/bussiness/BizGenerateButton";
import { isVip } from "@/utils/status";
import { GeneratePriceRules } from "../../hooks/useGenerateCost";
import { GenerateBizType } from "@/types/creator";

const LocalErase: React.FC = () => {
  const toastFn = useOwnToast();
  const lang = langStore.tgt;
  const imageAlias = statusStore.inpaintingImageAlias;
  const wh = useMemo(() => getNodeDisplayWH(imageAlias), [imageAlias, flagsStore.latestOpTime]);

  async function handleInpainting(): Promise<void> {
    const maskAlias = statusStore.inpaintingMaskAlias;

    await Actions.inpaintingWithBGFG({
      t: toastFn,
      lang,
      bgAlias: imageAlias,
      fgAlias: maskAlias,
      opt: {
        type: "inpainting",
        // useRefine,
        usePipeline: true,
        useFGAsImage: false,
      },
      noToast: false,
      checkBusy: !isVip(),
    });
  }
  return (
    <InpaintingPanel
      titleWord={Editor_Words["inpainting"]}
      labelWord={Editor_Words["local-erase-image-placeholder-title"]}
      maskTitleWord={Editor_Words["local-erase-mask-placeholder-title"]}
      // markAsMaskWord={Editor_Words["inpainting-mark-mask"]}
      submitPanel={
        <>
          <BizGenerateButton
            sticky
            pt="16px"
            size={wh ?? { w: 0, h: 0 }}
            generateCount={1}
            calcPriceProps={GeneratePriceRules[GenerateBizType.Erase]}
            buttonProps={{
              isDisabled: !statusStore.inpaintingReady,
            }}
            onSubmit={() => handleInpainting()}
          >
            {translate(Editor_Words["inpainting-submit"], lang)}
          </BizGenerateButton>
        </>
      }
    />
  );
};

export default observer(LocalErase);
